import { Vue, Options } from 'vue-class-component';
import { PlantType } from '@/../client-generator/generated-clients/plants';
import { ResidentialTypePlant } from '@/core/utils/EntrancePlant/entrance-plant.utils';

@Options({
  name: 'WizardPlantTypeSelection',
  props: {
    plantType: {
      required: true,
      type: Number as () => PlantType,
    },
    residentialType: {
      required: true,
      type: Number as () => ResidentialTypePlant,
    },
  },
  watch: {
    plantType: function (newVal: PlantType) {
      if (newVal === PlantType.ENTRANCE_PLANT) {
        this.rt = ResidentialTypePlant.NEW_PLANT;
      }
    }
  },
  emits: ['update:plantType', 'update:residentialType'],
})
export default class WizardPlantTypeSelection extends Vue {
  plantType!: PlantType;
  residentialType!: ResidentialTypePlant;

  Type = PlantType;

  get pt() {
    return this.plantType;
  }

  set pt(val) {
    this.$emit('update:plantType', val);
  }

  get rt() {
    return this.residentialType;
  }

  set rt(val) {
    this.$emit('update:residentialType', val);
  }

  get plantTypesImages() {
    return [
      {
        imageURLs: [require('@/assets/images/plants/plantType/smart-home.jpg')],
        value: PlantType.AUTOMATION_PLANT,
        title: this.$t('AppResourceEP.DomoticSmartHome').toString(),
        subTitle: `${this.$t('AppResource.MxServer').toString()}, ${this.$t(
          'AppResource.MyHomeServer1'
        ).toString()}`,
      },
      {
        imageURLs: [
          require('@/assets/images/entrancePlants/plantType/enrtance-plant.webp'),
        ],
        value: PlantType.ENTRANCE_PLANT,
        title: this.$t('AppResourceEP.ResidentialDoorEntrySystem').toString(),
        subTitle: this.$t('AppResourceEP.NewPeDevice').toString(),
      },
    ];
  }

  get residentialTypesButtons() {
    return [
      {
        imageURLs: require('@/assets/images/icons/icon-add.svg'),
        value: ResidentialTypePlant.NEW_PLANT,
        title: this.$t('AppResourceEP.EntrancePlantNewTitle').toString(),
        subTitle: `${this.$t('AppResourceEP.EntrancePlantNewDescription').toString()}`,
      },
      {
        imageURLs:require('@/assets/images/entrancePlants/icon-plant-configured.svg'),
        value: ResidentialTypePlant.CONFIGURED_PLANT,
        title: this.$t('AppResourceEP.EntrancePlantConfiguredTitle').toString(),
        subTitle: this.$t('AppResourceEP.EntrancePlantConfiguredDescription').toString(),
      },
    ];
  }

  changeRtValue(value: ResidentialTypePlant) {
    if(value === ResidentialTypePlant.NEW_PLANT){
      this.rt = value;
    }
    else {
      const faqUrl = "https://qna.legrand.com/linea-5000/b2e83fb2-e7f2-4d9a-b106-62fe3b444f8f/LIN018?";
      window.open(faqUrl, "_blank");
    }
  }
}
